import React, { useState, useEffect } from "react";

const VectorEmblem = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <rect x="2" y="2" width="36" height="36" rx="10" fill="#0F172A" />
    <circle cx="20" cy="16" r="5.2" fill="none" stroke="#F59E0B" strokeWidth="2" />
    <path d="M20 3.5V8M20 24v4.5M8 16h4M28 16h4" stroke="#0284C7" strokeWidth="2" strokeLinecap="round" />
    <rect x="11" y="26" width="18" height="7" rx="2" fill="#0284C7" />
    <rect x="14.5" y="28.5" width="3" height="2" rx="0.5" fill="#0F172A" />
    <rect x="22.5" y="28.5" width="3" height="2" rx="0.5" fill="#0F172A" />
  </svg>
);

// Uses provided src (from CMS) → then /assets/logo.svg → /assets/logo.png → vector fallback.
export const BrandLogo = ({ dark = false, size = 34, src = "" }) => {
  const sources = [src, "/assets/logo.svg", "/assets/logo.png"].filter(Boolean);
  const [idx, setIdx] = useState(0);
  useEffect(() => { setIdx(0); }, [src]);
  const failed = idx >= sources.length;

  if (!failed) {
    return (
      <img src={sources[idx]} onError={() => setIdx((i) => i + 1)} alt="Helios Cleantech"
        style={{ height: size }} className="w-auto object-contain" data-testid="brand-logo-img" />
    );
  }
  return (
    <span className="flex items-center gap-2.5">
      <VectorEmblem size={size} />
      <span className={`font-display font-extrabold text-[17px] tracking-tight leading-none ${dark ? "text-white" : "text-helios-slate"}`}>
        Helios<span className="text-helios-cyan">Cleantech</span>
      </span>
    </span>
  );
};
